import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { Container, Tab, Tabs } from 'react-bootstrap';
import { useWebsiteName } from '../../context/WebsiteNameContext';
import handleChangeWebsiteTab from '../../commons/ChangeWebsiteTab';

export default function PreviewReimbursementRefund() {
    const { state } = useLocation();
    const { websiteName, setWebsiteName } = useWebsiteName();

    useEffect(() => {
      handleChangeWebsiteTab({
        key: state?.name || "data",
        setWebsiteName,
        tabNames: { data: state?.label, }
      });
    }, []);
 
  return (
    <>
        <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Notification of work Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs justify activeKey={state?.name}>
        <Tab eventKey="create" title="สร้างใบขอเบิก"></Tab>
          <Tab eventKey="requisitions" title="สร้างใบขอเบิกงานขายและอื่นๆ"></Tab>
          <Tab eventKey="edit" title="แก้ไขใบขอเบิก"></Tab>
          <Tab eventKey="data" title="ข้อมูลใบขอเบิก"></Tab>
        </Tabs>
      </Container>
    </>
  )
}
